import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
  } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import QCXPageTemplate from '../../../../templates/page/QCXPageTemplate';
import { isFailureStatus, isLoadingStatus, isSuccessStatus } from  '../../../../utils/store/store-utils';
import { selectError,selectResponse,selectStatus } from '../../../../features/house/HouseSlice'
import HouseContext from '../../../../contexts/agenciamento/house/HouseContext';


export default function HousePage({ authInfo = {}, children }) {

    const dispatch = useDispatch();

    const status = useSelector(selectStatus);
    const error = useSelector(selectError);
    const response = useSelector(selectResponse);

    const isLoading = useMemo(() => (
        isLoadingStatus(status)
      ), [status]);

    const [successSnackbar, setSuccessSnackbar] = useState({
    open: false,
    message: '',
    });

    const [errorSnackbar, setErrorSnackbar] = useState({
    open: false,
    message: '',
    });

    const handleOpenSuccessSnackbar = useCallback((message) => {
    setSuccessSnackbar({
        open: true,
        message,
    });
    }, []);

    const handleOpenErrorSnackbar = useCallback((message) => {
    setErrorSnackbar({
        open: true,
        message,
    });
    }, []);

    const handleCloseSuccessSnackbar = useCallback(() => {
    setSuccessSnackbar({
        ...successSnackbar,
        open: false,
    });
    }, []);

    const handleCloseErrorSnackbar = useCallback(() => {
    setErrorSnackbar({
        ...errorSnackbar,
        open: false,
    });
    }, []);


    const providerData = useMemo(() => ({
        status,
        isLoading,
        successSnackbar,
        errorSnackbar,
        handleCloseSuccessSnackbar,
        handleCloseErrorSnackbar,
      }), [
        status,
        isLoading,
        successSnackbar,
        errorSnackbar,
        handleCloseSuccessSnackbar,
        handleCloseErrorSnackbar,
      ]);

    return (
        <>
            <HouseContext.Provider value={providerData}>
                <QCXPageTemplate contextComponent={HouseContext}>
                    {children}
                </QCXPageTemplate>
            </HouseContext.Provider>
        </>
    );
}